module.exports = __webpack_public_path__ + "static/media/g1p.6d693152.jpg";